<template>
<div>
  <h4>{{ $t('message.billsAmount.name') }}</h4>
  <vs-divider/>
  <template v-if="reportShow">
    <vs-popup class="holamundo" :title="$t('message.payment.confirmPaymentBySms')" :active.sync="reportShow">
      <div v-html="report"></div>
    </vs-popup>
  </template>
  <BillsStatistics
    :hide-chart="true"
    @get-selected-account="getAccountInfo"
  />
  <div class="form my-4 w-full">
    <vs-alert v-if="error" color="warning" class="mb-4">
      {{ $t('message.billsAmount.' + error) }}
    </vs-alert>
    <div class="w-full my-2">
      <div class="w-1/8 inline-block">{{ $t('message.billsAmount.formLabel') }}</div>
      <div class="w-1/8 inline-block">
        <div class="w-1/6 inline-block text-center">{{ $t('message.billsAmount.formLabelStart') }}</div>
        <datepicker
          class="w-3/4 inline-block"
          v-model="start"
          :language="lang[$i18n.locale]"
          :full-month-name="true"
          :monday-first="true"
          :format="'dd MMMM yyyy'"
        ></datepicker>
      </div>
      <div class="w-1/8 inline-block">
        <div class="w-1/6 inline-block text-center">{{ $t('message.billsAmount.formLabelEnd') }}</div>
        <datepicker
          class="w-3/4 inline-block"
          v-model="end"
          :language="lang[$i18n.locale]"
          :full-month-name="true"
          :monday-first="true"
          :format="'dd MMMM yyyy'"
        ></datepicker>
      </div>
    </div>
    <div class="w-full my-2">
      <div class="pr-2 inline-block">
      <vs-button @click="setPeriod('ys')" line-origin="left"
        color="primary" type="flat">
        {{ $t('message.billsAmount.buttonYesterday') }}
      </vs-button>
      </div>
      <div class="pr-2 inline-block">
      <vs-button @click="setPeriod('3d')" line-origin="left"
        color="primary" type="flat">
        {{ $t('message.billsAmount.button3Days') }}
      </vs-button>
      </div>
      <div class="pr-2 inline-block">
      <vs-button @click="setPeriod('w')" line-origin="left"
                 color="primary" type="flat">
        {{ $t('message.billsAmount.buttonWeek') }}
      </vs-button>
      </div>
      <div class="pr-2 inline-block">
      <vs-button @click="setPeriod('m')" line-origin="left"
                 color="primary" type="flat">
        {{ $t('message.billsAmount.buttonMount') }}
      </vs-button>
      </div>
      <div class="pr-2 inline-block">
      <vs-button @click="setPeriod('q')" line-origin="left"
                 color="primary" type="flat">
        {{ $t('message.billsAmount.buttonQuoter') }}
      </vs-button>
      </div>
      <div class="pr-2 inline-block">
      <vs-button @click="setPeriod('y')" line-origin="left"
                 color="primary" type="flat">
        {{ $t('message.billsAmount.buttonYear') }}
      </vs-button>
      </div>
    </div>
    <div class="w-full my-2">
      <vs-button
        @click="getAccountTransaction"
        color="primary" type="gradient">
        {{ $t('message.billsAmount.buttonCreate') }} >
      </vs-button>
      <div class="float-right inline-block">
        <div class="pr-2 inline-block">
        <vs-button
          @click="getTransactionReport('xlsx')"
          class="text-right hidden sm:block lg:block xl:block"
          color="primary" type="flat">
          {{ $t('message.billsAmount.buttonXLS') }}
        </vs-button>
        </div>
        <div class="inline-block">
        <vs-button
          @click="getTransactionReport('pdf')"
          class="text-right hidden sm:block lg:block xl:block"
          color="primary" type="flat">
          {{ $t('message.billsAmount.buttonPDF') }}
        </vs-button>
        </div>
      </div>
    </div>
  </div>
  <BillsTransactionTable @get-transfer-report="getReportTransferLinkAction"/>
</div>
</template>

<script>
import BillsStatistics from '@/layouts/components/common/BillsStatistics'
import BillsTransactionTable from '@/layouts/components/bills/BillsTransactionTable'
import Datepicker from 'vuejs-datepicker'
import { mapActions } from 'vuex'
import {en, ru} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
  name: 'BillsAmount',
  components: {BillsTransactionTable, BillsStatistics, Datepicker},
  data: () => ({
    start: null,
    end: null,
    accountNumber: null,
    id: null,
    error: null,
    reportShow: false,
    report: '',
    lang: { ru, en }
  }),
  methods: {
    ...mapActions('utils', ['fetchAccountTransaction', 'getReportLink', 'getReportTransferLink']),
    getAccountInfo (event) {
      this.accountNumber = event.accountNumber
      this.id = event.id
      if (this.start && this.end) this.getAccountTransaction()
    },
    setPeriod (type) {
      const start = new Date()
      const end = new Date()
      this.end = end
      switch (type) {
      case 'ys':
        this.start = start.setDate(end.getDate() - 1)
        this.end = end.setDate(end.getDate() - 1)
        break
      case '3d':
        this.start = start.setDate(end.getDate() - 3)
        break
      case 'w':
        this.start = start.setDate(end.getDate() - 7)
        break
      case 'm':
        this.start = start.setMonth(end.getMonth() - 1)
        break
      case 'q':
        this.start = start.setMonth(end.getMonth() - 3)
        break
      case 'y':
        this.start = start.setMonth(end.getMonth() - 12)
        break
      }
    },
    testData () {
      this.error = null

      if (!this.id || !this.accountNumber)  {
        this.error = 'errorAccount'
        return false
      }

      if (!this.start || !this.end) {
        this.error = 'errorPeriod'
        return false
      }

      const start = moment(this.start)
      const end = moment(this.end)

      return {start, end}
    },
    getAccountTransaction () {
      const {start, end} = this.testData()

      this.fetchAccountTransaction({
        accountNumber: this.accountNumber,
        id: this.id,
        data: {
          start: start.format('YYYY-MM-DD'),
          end: end.format('YYYY-MM-DD')
        }
      })
    },

    getTransactionReport (type) {
      const {start, end} = this.testData()

      this.getReportLink({
        accountNumber: this.accountNumber,
        id: this.id,
        type,
        data: {
          start: start.toISOString().slice(0, 10),
          end: end.toISOString().slice(0, 10)
        },
        lang: this.$i18n.locale
      })
    },

    async getReportTransferLinkAction (transactionId) {
      const result = await this.getReportTransferLink({
        transactionId, accountNumber: this.accountNumber, lang: this.$i18n.locale
      })
      window.open(result, 'Report', 'width=800,height=800,menubar=no,location=no,resizable=no')
    }
  },
  computed: {

  }
}
</script>
